/*
  MIXED BY NASRIN — dim the print swatches that are sold out in the size the
  shopper has selected. Rendered by snippets/mixed-print-swatches.liquid on the
  PDP only (the row becomes <print-swatch-sizes> there); cards have no size
  picker, so they carry no data and never load this file.

  Availability is baked in server-side as data-sizes="|XS|S|M|" per swatch, from
  variant.available. Preorder deliberately does NOT count as sold out: a preorder
  variant oversells, so it stays available at zero inventory — the same rule
  snippets/product-preorder.liquid uses to spot pre-orders (quantity at or below
  zero with continue selling on).

  Dimming is presentation only. The swatches stay links, because wanting that
  print in a different size is a perfectly good reason to click one.
*/
class PrintSwatchSizes extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('.mps__item[data-sizes]'));
    if (!this.items.length) return;

    this.onChange = this.onChange.bind(this);
    /* Listening on the document rather than the picker: Dawn re-renders parts
       of the product form on variant change, and a delegated listener does not
       care whether the radios it was bound to are still the same elements. */
    document.addEventListener('change', this.onChange);
    this.apply(this.selectedSize());
  }

  disconnectedCallback() {
    if (this.onChange) document.removeEventListener('change', this.onChange);
  }

  onChange(event) {
    const target = event.target;
    if (!target) return;
    // Radios use name="Size"; the dropdown picker uses name="options[Size]".
    if (target.name !== 'Size' && target.name !== 'options[Size]') return;
    this.apply(this.selectedSize());
  }

  selectedSize() {
    const checked = document.querySelector('fieldset.product-form__input input[name="Size"]:checked');
    if (checked) return checked.value;
    const select = document.querySelector('select[name="options[Size]"]');
    return select ? select.value : null;
  }

  apply(size) {
    this.items.forEach((item) => {
      const sizes = item.dataset.sizes || '';
      const unavailable = Boolean(size) && sizes.indexOf('|' + size + '|') === -1;
      item.classList.toggle('is-size-unavailable', unavailable);

      // Keep the state out of the visual layer only; screen readers get it too.
      const swatch = item.querySelector('.mps__swatch[aria-label]');
      if (!swatch) return;
      if (!swatch.dataset.labelBase) swatch.dataset.labelBase = swatch.getAttribute('aria-label');
      swatch.setAttribute(
        'aria-label',
        unavailable ? swatch.dataset.labelBase + ' (sold out in ' + size + ')' : swatch.dataset.labelBase
      );
    });
  }
}

customElements.define('print-swatch-sizes', PrintSwatchSizes);
